const FormField = ({
  children,
  label,
  caption,
}: {
  children: React.ReactNode;
  label: string;
  caption?: string;
}) => {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-xs text-gray-500">{label}</p>
      {children}
      {caption && <p className="text-xs text-gray-500/50">{caption}</p>}
    </div>
  );
};

export default FormField;
